import { render, staticRenderFns } from "./IconStar.vue?vue&type=template&id=692b7e03&scoped=true&"
import script from "./IconStar.vue?vue&type=script&lang=js&"
export * from "./IconStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692b7e03",
  null
  
)

export default component.exports